/*
 * Constants.
 */

export const sidePanelSwitcherWidth = 64; // px.
